import { cn } from '../../../lib/utils'
import { catalogArtworkKind } from './catalog-artwork-style'

type Props = {
  category: string
  className?: string
}

export function CatalogArtwork({ category, className }: Props) {
  const kind = catalogArtworkKind(category)

  if (kind === 'tote') {
    return (
      <svg
        viewBox="0 0 220 170"
        aria-hidden="true"
        className={cn('text-[#b89d7a]', className)}
      >
        <path
          d="M64 59V43c0-24 14-38 36-38h20c22 0 36 14 36 38v16"
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          strokeLinecap="round"
        />
        <path d="M36 59h148l9 106H27L36 59Z" fill="#e9d9c2" />
        <path d="M36 59h148" stroke="#d7c2a5" strokeWidth="2" />
      </svg>
    )
  }

  if (kind === 'frame') {
    return (
      <svg viewBox="0 0 210 160" aria-hidden="true" className={className}>
        <g transform="rotate(4 105 80)">
          <rect x="35" y="13" width="142" height="140" rx="2" fill="#3d4240" />
          <path d="M44 22h124v122H44z" fill="#d8b9ad" />
          <path d="m44 144 124-122v55l-70 67Z" fill="#678177" />
          <path d="m98 144 70-67v67Z" fill="#ede3d6" />
        </g>
      </svg>
    )
  }

  if (kind === 'jewelry') {
    return (
      <svg viewBox="0 0 210 150" aria-hidden="true" className={className}>
        <ellipse cx="102" cy="92" rx="54" ry="31" fill="#d8d8d4" />
        <ellipse cx="102" cy="92" rx="34" ry="18" fill="#eee6df" />
        <path
          d="m78 58 24-28 25 28-25 21-24-21Z"
          fill="#f5f4ef"
          stroke="#a8aaa6"
          strokeWidth="3"
        />
        <path d="m88 58 14-28 14 28-14 21-14-21Z" fill="#dfe6e7" />
      </svg>
    )
  }

  if (kind === 'shirt') {
    return (
      <svg viewBox="0 0 220 170" aria-hidden="true" className={className}>
        <path
          d="m70 22 22-13c9 11 27 11 36 0l22 13 55 33-25 42-25-14v82H65V83L40 97 15 55l55-33Z"
          fill="#f7f6f2"
        />
        <path d="M92 9c2 22 34 22 36 0" fill="none" stroke="#deded9" strokeWidth="3" />
      </svg>
    )
  }

  return (
    <svg viewBox="0 0 210 160" aria-hidden="true" className={className}>
      <path
        d="M48 33h102v105c0 10-8 18-18 18H66c-10 0-18-8-18-18V33Z"
        fill="#f6f1e9"
      />
      <path
        d="M150 60h13c24 0 35 14 35 33s-12 34-36 34h-12"
        fill="none"
        stroke="#f6f1e9"
        strokeWidth="16"
      />
      <path d="M48 34h102" stroke="#e5ddd1" strokeWidth="3" />
    </svg>
  )
}
